"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./Popover.scss");

var _excluded = ["text", "title", "maxWidth", "skin", "placement", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The text inside the content area of the popover */
  text: _propTypes.string,

  /** Add your own custom id to the component */
  id: _propTypes.string,

  /** The text inside the header area of the popover */
  title: _propTypes.string,

  /** Set the max width in pixels */
  maxWidth: _propTypes.number,

  /** Dark background */
  skin: (0, _propTypes.oneOf)(['white', 'dark']),

  /** Placement of the arrow relative to the tooltip */
  placement: (0, _propTypes.oneOf)(['top', 'right', 'bottom', 'left']),

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  skin: 'white',
  placement: 'top',
  maxWidth: 280
};
/**
 * A popover is a pattern used to show helpful information that is related to a particular element.
 * It can contain a title and multiple lines of text, and be attached to any element.
 * */

var Popover = function Popover(_ref) {
  var text = _ref.text,
      title = _ref.title,
      maxWidth = _ref.maxWidth,
      skin = _ref.skin,
      placement = _ref.placement,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-popover', {
    'rds-popover--placement-top': placement === 'top',
    'rds-popover--placement-right': placement === 'right',
    'rds-popover--placement-bottom': placement === 'bottom',
    'rds-popover--placement-left': placement === 'left',
    'rds-popover--white': skin === 'white',
    'rds-popover--dark': skin === 'dark'
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassNames
  }, rest, maxWidth && {
    style: {
      maxWidth: maxWidth + 'px'
    }
  }), title && /*#__PURE__*/_react.default.createElement("div", {
    className: 'rds-popover__header'
  }, title), text && /*#__PURE__*/_react.default.createElement("div", {
    className: 'rds-popover__content'
  }, text));
};

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
var _default = Popover;
exports.default = _default;